import React from 'react';
import Reflux from 'reflux';
import { Map, OrderedMap, List } from 'immutable';
import Modal from 'shared/components/misc/modal.jsx';
import UIRegions from 'shared/constants/UIRegions';
import { Row, Col, Input, Button } from 'bootstrap';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import classnames from 'classnames';
import TagList from 'shared/components/tag/tagList';
import AddTagMenu from 'shared/components/tag/addTagMenu';
import EventShowsMenu from 'shared/components/menus/eventShowMenu';
import ElementsList from './elementsList';
import ItemsList from './itemsList';
import GlobalElementsActivation from 'shared/components/team/globalElementsActivation';
import EventCategorizedShowList from 'shared/components/show/eventCategorizedShowList';
import Dropdown from 'shared/components/menus/dropDown.jsx';
import role from 'shared/lib/role';
import MigrateGlobalElementCategoriesToLabelsModal from 'main/components/team/migrateGlobalElementCategoriesToLabelsModal';

import ModalStore from 'flux/stores/ModalStore';
import UserSessionStore from 'flux/stores/UserSessionStore';
import GlobalElementActions from 'flux/actions/GlobalElementActions';
import GlobalElementStore from 'flux/stores/GlobalElementStore';
import GlobalElementModalActions from 'flux/actions/GlobalElementModalActions';
import GlobalElementModalStore from 'flux/stores/GlobalElementModalStore';
import RouteActions from 'flux/actions/RouteActions';
import ModalActions from 'flux/actions/ModalActions';
import { ViewRelativePaths } from 'shared/constants/CuesheetViews';

//Get rows helper
const getRows = (st) => st.get('rows');

/**
 * Insert Global Elements Modal
 */
export default React.createClass({
  mixins: [
    Reflux.ListenerMixin,
    Reflux.connectFilter(GlobalElementStore, 'globalElementRows', getRows),
    Reflux.connectFilter(GlobalElementModalStore, 'showRows', getRows),
    Reflux.connect(GlobalElementModalStore, 'globalElementModal'),
    Reflux.connect(GlobalElementStore, 'globalElement'),
    Reflux.connect(UserSessionStore, 'user'),
    Reflux.connectFilter(ModalStore, 'modalIsVisible', (modalVisibility) => {
      if (
        !modalVisibility ||
        !modalVisibility.has(UIRegions.InsertGlobalElementsModal)
      )
        return false;
      return modalVisibility.get(UIRegions.InsertGlobalElementsModal);
    }),
  ],

  displayName: 'InsertGlobalElementsModal',

  contextTypes: {
    router: React.PropTypes.object.isRequired,
  },

  getInitialState() {
    return {
      searchFocusState: false,
      labelFilter: List(),
    };
  },

  componentDidUpdate(prevProps, prevState) {
    if (this.state.modalIsVisible && !prevState.modalIsVisible) {
      const { teamId } = this.context.router.state.params;
      if (this._isTeamAdmin(teamId)) GlobalElementActions.populate(teamId);
    }
  },

  _isTeamAdmin(teamId) {
    const { user } = this.state;

    if (!user) return;

    return role.hasTeamAdminRole(user, teamId);
  },

  _handleNavigateGlobalElementClick() {
    const { globalElement } = this.state;

    ModalActions.hide(UIRegions.InsertGlobalElementsModal);

    RouteActions.goToGlobalElementManager({
      teamId: globalElement.get('teamId'),
      eventId: globalElement.get('eventId'),
      showId: globalElement.get('showId'),
    });
  },

  render() {
    const titleNode = this._getModalTitle();

    const { globalElement, globalElementModal } = this.state;

    const { teamId } = this.context.router.state.params;

    let modalBody = (
      <div>
        <MigrateGlobalElementCategoriesToLabelsModal />
        <Col lg={9} md={8} sm={8} xs={8}>
          <Row>
            <Col lg={24} md={24}>
              <EventShowsMenu
                onShowClick={(event, show) =>
                  GlobalElementModalActions.populate(
                    teamId,
                    event.get('_id'),
                    show.get('_id'),
                  )
                }
                placement="bottom"
                popoverId="geEventShowsMenu"
                caretIcon={<Icon name="angle-down" />}
                events={globalElementModal.get('events')}
                activeShow={globalElementModal.get('activeShow')}
              />
              {this._getGoToShowLink()}
            </Col>
          </Row>
          <Row>
            <Col lg={24} md={24}>
              {this._getItemRows()}
            </Col>
          </Row>
        </Col>
        <Col lg={1} md={1} sm={1} xs={1} className="ge-col-splitter" />
        <Col lg={14} md={15} sm={15} xs={15}>
          <Row>
            <Col lg={16} md={16}>
              <div className="ge-insert-section-title ge">
                {this._getElementSetSelector()}
                {this._getElementManagerLinkNode()}
              </div>
            </Col>
            <Col lg={6} md={6} className="hidden-sm hidden-xs">
              {this._getSearchInputNode()}
            </Col>
          </Row>
          <Row>{this._getGlobalElements()}</Row>
        </Col>
      </div>
    );

    if (!globalElement.get('event')) {
      modalBody = <GlobalElementsActivation />;
    }

    return (
      <Modal
        className="ge-insert-modal"
        headerClassName="modal-generic-header"
        dialogClassName="ge-insert-dialog"
        name={UIRegions.InsertGlobalElementsModal}
        title={<span>{titleNode}</span>}
        hasRowClass={false}
      >
        <div className="ge-insert-modal-body-content">{modalBody}</div>
      </Modal>
    );
  },

  _getElementManagerLinkNode() {
    //This is not supposed to show on the global element manager, since you are already there
    if (
      window.location.pathname.indexOf(`/${ViewRelativePaths.GlobalElement}`) >=
      0
    )
      return null;

    return (
      <div
        className="ge-insert-goto-ge-link"
        onClick={() => this._handleNavigateGlobalElementClick()}
      >
        Go to Element Manager
      </div>
    );
  },

  _getElementSetSelector() {
    const state = this.state.globalElement;

    if (!state.get('elementSets')) return null;

    const elementSetConfig = Map({
      noCaret: false,
      icon: null,
      content: state.getIn(['activeElementSet', 'title']),
      items: state
        .get('elementSets')
        .filter(
          (elementSet, elementSetId) => elementSetId !== state.get('showId'),
        )
        .map((elementSet, elementSetId) => {
          return Map({
            type: 'link',
            content: elementSet.get('title'),
            onClick: () =>
              GlobalElementActions.populateElementSet(
                state.get('teamId'),
                state.get('eventId'),
                elementSetId,
              ),
          });
        }),
    });

    return (
      <Dropdown
        classes="generic-dropdown-menu ge-insert-modal-elementset-dropdown"
        config={elementSetConfig}
      />
    );
  },

  _getGoToShowLink() {
    const { globalElementModal } = this.state;

    if (!globalElementModal.get('activeShow')) return null;

    const teamId = globalElementModal.get('teamId'),
      eventId = globalElementModal.get('eventId'),
      showId = globalElementModal.get('showId');

    const { showId: currentShowId } = this.context.router.state.params;
    if (currentShowId === showId) return;

    return (
      <span
        onClick={() => {
          ModalActions.hide(UIRegions.InsertGlobalElementsModal);
          RouteActions.goToShow({
            teamId,
            eventId,
            showId,
            relativePath: ViewRelativePaths.Compact,
          });
        }}
        className="ge-insert-modal-show-link hidden-md hidden-sm hidden-xs"
      >
        Go to show
      </span>
    );
  },

  _getEventCategorizedShowList() {
    const { globalElementModal } = this.state;
    const { teamId } = this.context.router.state.params;

    if (globalElementModal.get('activeShow')) return null;

    return (
      <div className="ge-insert-modal-show-list">
        <EventCategorizedShowList
          onChange={(eventId, showId) =>
            GlobalElementModalActions.populate(teamId, eventId, showId)
          }
          events={globalElementModal.get('events')}
          activeShow={globalElementModal.get('activeShow')}
        />
      </div>
    );
  },

  _getNoRowMatchesPlaceholder() {
    const { globalElement } = this.state;

    const rowsSearchTerm = globalElement.get('rowsSearchTerm');
    const rowsSearched = globalElement.get('rowsSearched');

    if (rowsSearchTerm && (!rowsSearched || rowsSearched.length < 1)) {
      return (
        <div className="ge-insert-modal-no-rows-placeholder">
          <p>No matches found...</p>
        </div>
      );
    } else {
      return null;
    }
  },

  _getGERows() {
    const { globalElement, globalElementRows, labelFilter } = this.state;

    let matchedRows = globalElementRows;

    const rowsSearchTerm = globalElement.get('rowsSearchTerm');
    const rowsSearched = globalElement.get('rowsSearched');

    if (rowsSearchTerm) {
      matchedRows =
        rowsSearched && rowsSearched.size > 0 ? rowsSearched : OrderedMap();
    }

    if (labelFilter && labelFilter.size > 0) {
      matchedRows = matchedRows.filter((ge) => {
        if (!labelFilter || labelFilter.size < 1) return true;

        let allLabelFiltersMatched = true;

        labelFilter.forEach((labelFilterId) => {
          const itemLabels = ge.get('labels');

          if (
            !itemLabels ||
            itemLabels.length < 1 ||
            itemLabels.indexOf(labelFilterId) === -1
          ) {
            allLabelFiltersMatched = false;
          }
        });

        return allLabelFiltersMatched;
      });
    }

    return matchedRows;
  },

  _getGlobalElements() {
    const { globalElement, globalElementModal, labelFilter } = this.state;

    const tagFilterPopoverId = 'addTagFilterMenuInsertModal';

    return (
      <Col lg={24} md={24}>
        <Row className="ge-insert-modal-col-wrapper">
          <Col lg={12} md={10} sm={9}>
            <div className="ge-insert-modal-col-title name">Element Name</div>
          </Col>
          <Col lg={10} md={13} className="hidden-sm hidden-xs">
            <div className="ge-insert-modal-col-title">
              <AddTagMenu
                popoverTitle="Filter by tag(s)"
                displayNode={this._getTagFilterDisplayNode()}
                tags={globalElement.get('tags')}
                activeTagIds={labelFilter}
                wrapperClasses="ge-insert-modal-tag-filter-wrapper"
                placement="bottom"
                popoverId={tagFilterPopoverId}
                isFilter
                displayClear
                clearText="Clear all filters"
                onChange={(tagIds) => {
                  this._handleFilterSelection(tagIds, 'label');
                }}
              />
              {this._getActiveTagFilterList(tagFilterPopoverId)}
            </div>
          </Col>
          <Col lg={2} className="hidden-sm hidden-xs hidden-md">
            <div className="ge-insert-modal-col-title">Duration</div>
          </Col>
        </Row>
        <Row className="ge-modal-elements-list-wrapper">
          <Col lg={24} md={24} sm={24}>
            <ElementsList
              eventId={globalElement.get('eventId')}
              showId={globalElement.get('showId')}
              itemSetListId={globalElement.get('itemSetListId')}
              itemSetId={globalElement.get('itemSetId')}
              items={this._getGERows()}
              tags={globalElement.get('tags')}
              activeGlobalElementShowItems={globalElementModal.get(
                'globalElementShowItems',
              )}
            />
            {this._getNoRowMatchesPlaceholder()}
          </Col>
        </Row>
      </Col>
    );
  },

  _getTagFilterDisplayNode() {
    return (
      <span>
        <Button>
          <Icon name="tag" /> Tags <Icon name="angle-down" />
        </Button>
      </span>
    );
  },

  // eslint-disable-next-line no-unused-vars
  _getActiveTagFilterList(tagFilterPopoverId) {
    const { globalElement, labelFilter } = this.state;
    const tags = globalElement.get('tags');

    if (!labelFilter || labelFilter.size < 1) return null;

    const activeTags = OrderedMap(
      labelFilter
        .map((tagId) => [tagId, tags.get(tagId)])
        .filter((item) => item[1]),
    );

    return (
      <div className="ge-insert-modal-active-tag-filters">
        <TagList
          width={220}
          tags={activeTags}
          popoverId="ge-insert-modal-tag-filters-popover"
          popoverTitle="Applied tag filters"
          onRemove={this._handleTagRemoval}
          disableFilterSorting={false}
          isFilter
          tagFilters={tags}
          onFilterChange={(tagIds) => {
            this._handleFilterSelection(tagIds, 'label');
          }}
        />
      </div>
    );
  },

  _handleTagRemoval(tagId) {
    const { labelFilter } = this.state;

    let activeTagIds = labelFilter;

    const tagIndex = activeTagIds.indexOf(tagId);
    activeTagIds = activeTagIds.delete(tagIndex);

    this._handleFilterSelection(activeTagIds, 'label');
  },

  _getItemRows() {
    const { showRows, globalElementRows, globalElementModal } = this.state;

    const disableDrop =
      !globalElementRows || globalElementRows.size === 0 ? true : false;
    const scrollTo =
      globalElementModal.get('latestRenderedCuesheetRowIndex') || 0;
    const scrollDirection = globalElementModal.get('cuesheetScrollDirection');

    return (
      <Row className="ge-modal-items-list-wrapper">
        <Col lg={24} md={24} sm={24}>
          <ItemsList
            scrollTo={scrollTo}
            scrollDirection={scrollDirection}
            items={showRows}
            disableDrop={disableDrop}
            onDelete={GlobalElementModalActions.deleteRow}
          />
        </Col>
      </Row>
    );
  },

  _getSearchInputNode() {
    const { globalElement, searchFocusState } = this.state;
    const rowsSearchTerm = globalElement.get('rowsSearchTerm');
    const hasValue = this._getSearchTermValue();

    return (
      <div className="search-container-header-input">
        <span
          className={classnames('search-wrapper', {
            'has-focus': searchFocusState,
          })}
        >
          <Input
            type="text"
            autoFocus
            placeholder="Search for global element"
            className={classnames('search-input', { 'has-value': hasValue })}
            value={rowsSearchTerm}
            addonBefore={<span>{this._getSearchPreControl()}</span>}
            onChange={(e) => this._handleSearchChange(e.target.value)}
            onFocus={() => this._toggleSearchInputFocus()}
            onBlur={() => this._toggleSearchInputFocus()}
          />
        </span>
      </div>
    );
  },

  _handleFilterSelection(ids, type) {
    return this.setState({ [`${type}Filter`]: ids });
  },

  _getModalTitle() {
    return (
      <Row>
        <Col lg={17} md={17} sm={17}>
          <h4 className="ge-insert-modal-title">Insert Global Elements</h4>
        </Col>
      </Row>
    );
  },

  _toggleSearchInputFocus() {
    const { searchFocusState } = this.state;
    this.setState({ searchFocusState: !searchFocusState });
  },

  _getSearchTermValue() {
    const { globalElement } = this.state;
    const searchTerm = globalElement.get('rowsSearchTerm');

    return searchTerm ? searchTerm : null;
  },

  _getSearchPreControl() {
    const hasValue = this._getSearchTermValue();

    const searchNode = (
      <span className="search-prefix-wrapper">
        <Icon name="search" />
      </span>
    );

    const removeNode = (
      <span
        onClick={() => this._clearSearchTerm()}
        className="search-prefix-wrapper remove"
      >
        <Icon name="times" />
      </span>
    );

    return hasValue ? removeNode : searchNode;
  },

  _clearSearchTerm() {
    GlobalElementActions.rowsClearSearch();
  },

  _handleSearchChange(searchTerm) {
    GlobalElementActions.rowsSearch(searchTerm);
  },
});
